import React, { memo } from 'react';
import { Link } from 'wouter';
import ThemeToggle from './ThemeToggle';

const quickLinks = [
  { href: '/', label: 'Home' },
  { href: '/about', label: 'About' },
  { href: '/programmes', label: 'Programmes' },
  { href: '/impact', label: 'Impact' },
  { href: '/partners', label: 'Partners' },
  { href: '/governance', label: 'Governance' },
  { href: '/donate', label: 'Donate' },
  { href: '/contact', label: 'Contact' },
];

const Footer = memo(function Footer() {
  return (
    <footer className="bg-[radial-gradient(circle_at_top,#0f172a,#020617)] text-slate-100" role="contentinfo" aria-label="Site footer">
      <div className="container mx-auto px-4 py-14">
        <div className="grid gap-10 md:grid-cols-[1.2fr_0.9fr_0.9fr]">
          <section>
            <img src="/assets/logo/mef-logo-wt.png" alt="MakersPlace Educational Foundation" className="mb-4 h-24 w-auto" />
            <p className="max-w-sm text-sm leading-7 text-slate-300">
              MakersPlace Educational Foundation is a subsidiary of The MakersPlace, established to make computing education accessible to learners in all communities.
            </p>
            <Link href="/donate" className="mt-6 inline-flex rounded-full bg-primary px-4 py-2 text-sm font-semibold text-white transition-all hover:-translate-y-0.5 hover:brightness-110">
              Support the Foundation
            </Link>
          </section>

          <nav aria-label="Footer quick links">
            <h2 className="mb-4 text-lg font-semibold text-white">Quick Links</h2>
            <ul className="space-y-2">
              {quickLinks.map((link) => (
                <li key={link.href}>
                  <Link href={link.href} className="text-slate-300 transition-colors hover:text-primary">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <section>
            <h2 className="mb-4 text-lg font-semibold text-white">Contact</h2>
            <ul className="space-y-3 text-sm text-slate-300">
              <li>
                <span className="font-medium text-white">Email:</span> info@makersplacegh.com
              </li>
              <li>
                <span className="font-medium text-white">Phone:</span> +233 55 631 0034
              </li>
              <li>
                <span className="font-medium text-white">Address:</span> Magmens Lake, Westlands Boulevard, Accra, Ghana
              </li>
            </ul>
            <Link href="/contact" className="mt-6 inline-flex rounded-full border border-white/20 bg-white/10 px-4 py-2 text-sm font-semibold text-white transition-all hover:-translate-y-0.5 hover:bg-white/15">
              Partner With Us
            </Link>
          </section>
        </div>
      </div>

      <div className="border-t border-slate-800">
        <div className="container mx-auto flex flex-col items-center justify-between gap-3 px-4 py-4 text-xs text-slate-400 md:flex-row">
          <p>&copy; {new Date().getFullYear()} MakersPlace Educational Foundation. All rights reserved.</p>
          <div className="flex items-center gap-3">
            <p>Built for trusted, inclusive, and measurable impact.</p>
            <ThemeToggle />
          </div>
        </div>
      </div>
    </footer>
  );
});

Footer.displayName = 'Footer';

export default Footer;
